
export default {
  data() {
    return {
      selectedEft: null,
    }
  },
  props: {
    getValidPayments: {
      default: () => {},
    },
  },
}
